module.exports = __webpack_public_path__ + "1792395595471/fonts/socicon.9a64ef9.ttf";